import { useEffect } from "react";

export default function ImpersonationStart() {
  useEffect(() => {
    const actorUrl = sessionStorage.getItem("imp_actor_url");
    sessionStorage.removeItem("imp_actor_url");

    if (!actorUrl) {
      window.location.assign("/");
      return;
    }

    window.location.assign(actorUrl);
  }, []);

  return null;
}